// Pure helpers used by CheckoutFormReduxWithSplitit.vue. Kept separate so
// they can be unit-tested without compiling the .vue component.

export const splititInstallmentAmount = (value, numberOfPayments) => {
  const amount = Number(value) || 0
  const installments = Number(numberOfPayments) || 0
  return installments > 0 ? amount / installments : amount
}

export const buildSplititCustomer = form => ({
  fullName: `${form.firstName || ''} ${form.lastName || ''}`.trim(),
  email: form.email,
  phoneNumber: form.phone
})

export const buildSplititAddress = info => {
  const a = info || {}
  return {
    addressLine1: a.address,
    city: a.city,
    state: a.state,
    zip: a.zip,
    country: a.country
  }
}

// Order body for /splitit/initiate. creditCardInfo is omitted — FlexForm
// captures the card later.
export const buildSplititInitiateBody = ({ state, getters, form }) => {
  const { creditCardInfo, ...formWithoutCC } = form
  return {
    slug: state.slug,
    sessionId: (getters && getters.sessionId) || null,
    queryParameters: state.queryParameters,
    ...(state.customer || {}),
    ...formWithoutCC
  }
}

export const buildSplititOrderPayload = ({ state, getters, form }) => ({
  slug: state.slug,
  sessionId: (getters && getters.sessionId) || null,
  queryParameters: state.queryParameters,
  ...(state.customer || {}),
  ...form
})

export const extractSplititErrorMessage = err => {
  if (!err) return 'There was a problem with your payment. Please try again.'
  if (err.response && err.response.data && err.response.data.errors) {
    const errs = err.response.data.errors
    if (errs.message) return errs.message
    if (errs.Application && errs.Application[0] && errs.Application[0].message)
      return errs.Application[0].message
  }
  if (err.message) return err.message
  return 'There was a problem with your payment. Please try again.'
}

// Calls $salesApi.order with the Splitit IDs attached. Returns
// { ok: true, data } on success or { ok: false, message } on a handled error.
export const submitSplititPlaceOrder = async ({
  salesApi,
  splititIpn,
  stickyOrderId,
  order,
  splitTestFunnel
}) => {
  try {
    const result = await salesApi.order(
      { ...order, splititIpn, stickyOrderId },
      splitTestFunnel
    )
    if (result.paymentError) {
      return { ok: false, message: result.paymentError }
    }
    return { ok: true, data: result.confirmation }
  } catch (err) {
    return { ok: false, message: extractSplititErrorMessage(err), err }
  }
}
